// hooks/useAddLead.js
import { useCallback, useState } from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import callApi from "../../../utility/apiCaller";

export default function useAddLead() {
  const [searchParams] = useSearchParams();
  const [affId, setAffId] = useState(null);
  useEffect(() => {
    setAffId(searchParams.get("aff_id"));
  }, [searchParams]);

  const addLead = useCallback(
    async ({ leadId, lead_type = "live", priority = 1, stage = "Have offer" }) => {
     

     
      if (affId === "2") {
        console.warn("aff_id=2 found → API not called");
        return { skipped: true };
      }

      try {
        const res = await callApi(
          "v1/crm/add-lead",
          "post",
          {
            leadId,
            lead_type,
            priority,
            stage,
          },
          "core"
        );

        return res;
      } catch (err) {
        console.error("Error adding lead:", err);
        throw err;
      }
    },
    [affId]
  );

  return addLead;
}
